import * as React from 'react';
import {useEffect} from 'react';
import isEmpty from "lodash/isEmpty";

import {
    useResidenceExplorerStore,
    selectExplorerObjects,
    selectResidenceExplorerLoading,
    selectShowSunStudy,
} from "features/residenceExplorer/store/useResidenceExplorerStore";
import {useDeviceStore, selectIsMobile} from "features/ui/store/useDeviceStore";
import {ResidenceExplorerSetup} from "features/residenceExplorer/types";
import {ResidenceExplorerView} from "features/residenceExplorer/components/ResidenceExplorerV2/_residenceExplorerView";
import {
    ResidenceExplorerHeader
} from "features/residenceExplorer/components/ResidenceExplorerV2/_residenceExplorerHeader";
import {
    ResidenceExplorerLoader
} from "features/residenceExplorer/components/ResidenceExplorerV2/_residenceExplorerLoader";
import {
    ResidenceExplorerFilters
} from "features/residenceExplorer/components/ResidenceExplorerV2/_residenceExplorerFilters";
import {
    ResidenceExplorerMobileNavigation
} from "features/residenceExplorer/components/ResidenceExplorerV2/_residenceExplorerMobileNavigation";
import {
    ResidenceExplorerSunStudyControls
} from "features/residenceExplorer/components/ResidenceExplorerV2/_residenceExplorerSunStudyControls";

import './style.scss';

import {useAuth} from "features/authentication/hooks/useAuth";

interface Props {
    settings: ResidenceExplorerSetup;
}

export const ResidenceExplorerV2: React.FunctionComponent<Props> = ({settings}) => {
    const objects = useResidenceExplorerStore(selectExplorerObjects);
    const showSunStudy = useResidenceExplorerStore(selectShowSunStudy);
    const loading = useResidenceExplorerStore(selectResidenceExplorerLoading);
    const setupResidenceExplorer = useResidenceExplorerStore(state => state.setupResidenceExplorer);
    const resetExplorer = useResidenceExplorerStore(state => state.resetExplorer);
    const isMobile = useDeviceStore(selectIsMobile);
    const {isLoggedIn, user} = useAuth();

    useEffect(() => {
        if(settings) {
            setupResidenceExplorer(settings, user);
        }

        return () => {
            resetExplorer();
        }
    }, [isLoggedIn]);

    if(loading) return <ResidenceExplorerLoader />;
    if(isEmpty(objects)) return null;

    return (
        <div className="residence-explorer">
            <ResidenceExplorerHeader />

            { settings.hasExplorer &&
                <>
                    <ResidenceExplorerView />

                    {isMobile && <ResidenceExplorerMobileNavigation />}

                    {showSunStudy ?
                        <ResidenceExplorerSunStudyControls /> :
                        <ResidenceExplorerFilters />
                    }
                </>
            }

        </div>
    );
};
